"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = exports.Invocations = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
const serviceTaskInvocations = require("./ServiceTask");
const userTaskTypes = require("./UserTask");
__exportStar(require("./ActivityBase"), exports);
__exportStar(require("./BusinessRuleTask"), exports);
__exportStar(require("./CallActivity"), exports);
__exportStar(require("./EmptyActivity"), exports);
__exportStar(require("./ManualTask"), exports);
__exportStar(require("./ReceiveTask"), exports);
__exportStar(require("./ScriptTask"), exports);
__exportStar(require("./SendTask"), exports);
__exportStar(require("./ServiceTask"), exports);
__exportStar(require("./SubProcess"), exports);
__exportStar(require("./UserTask"), exports);
// NOTE: This is only for backwards compatibility, to avoid a breaking change.
var Invocations;
(function (Invocations) {
    Invocations.Invocation = serviceTaskInvocations.Invocation;
    Invocations.MethodInvocation = serviceTaskInvocations.MethodInvocation;
})(Invocations = exports.Invocations || (exports.Invocations = {}));
var Types;
(function (Types) {
    Types.FormFieldEnumValue = userTaskTypes.FormFieldEnumValue;
    Types.UserTaskFormField = userTaskTypes.UserTaskFormField;
})(Types = exports.Types || (exports.Types = {}));
//# sourceMappingURL=index.js.map